exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".paper {\n  background-color: #fff;\n  padding: 20px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n          box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  margin: 15px 0; }\n", "", {"version":3,"sources":["/usr/src/app/src/components/Paper/Paper.scss"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,cAAc;EACd,8CAA8C;EAC9C,qFAA6E;UAA7E,6EAA6E;EAC7E,eAAe,EAAE","file":"Paper.scss","sourcesContent":[".paper {\n  background-color: #fff;\n  padding: 20px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  margin: 15px 0; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/Paper/Paper.scss
// module id = 1410
// module chunks = 0